<template>
  <div class="main-content">

 <div class="container pt-100">
        <!-- Section Content -->
        <div class="section-content">
          <div class="row">
            <div class="col-md-12">
    <h2 class="text-theme-colored text-center">Cookies</h2>
            </div>
          </div>
        </div>
      </div>
    
    <!-- Section: Terms -->
    <section id="terms cookie-mobile">
      <div class="container pt-70">
        <div class="section-content">
          <p>
            La ditta individuale di Abdessalem Sarah (P.Iva 04457370163), con sede legale a 20063 -
            Cernusco sul Naviglio (MI), Via Andrea Fermini n. 1, utilizza i cookie per migliorare il proprio

            Sito Internet e per fornire servizi e funzionalità agli utenti. È possibile limitare o disattivare l’utiliz-
            zo dei cookie tramite il proprio browser Web. Tuttavia, in questo caso alcune funzionalità del sito

            potrebbero diventare inaccessibili.
            
            <h5 class="text-theme-dark">Dati di navigazione</h5>

I sistemi informatici e le procedure software preposte al funzionamento del sito web https://www.-
sarahfitnessmovementflow.com acquisiscono, nel corso del loro normale esercizio, alcuni dati personali la cui trasmissione è implicita all’uso dei protocolli di comunicazione di Internet.
Si tratta di informazioni che non sono raccolte per essere associate a interessati identificati, ma che,
per loro stessa natura, potrebbero, attraverso elaborazioni ed associazioni con dati detenuti da terzi,
permettere di identificare gli utenti.
In questa categoria di dati rientrano: 
            <br />

<p>- indirizzi IP o i nomi a dominio dei computer utilizzati dagli Utenti connessi al sito;</p>
<p>- gli indirizzi di notazione URI (Uniform Resource Identifier) delle risorse richieste, l’orario della
richiesta, il metodo utilizzato nel sottoporre la richiesta al server; la dimensione del file ottenuto
in risposta; il codice numerico indicante lo stato della risposta data dal server (buon fine, errore,
ecc..) ed altri parametri relativi al sistema operativo e all’ambiente informatico dell’Utente. </p>

Questi dati vengono utilizzati al solo fine di ricavare informazioni statistiche anonime sull’uso del
sito e per controllarne il corretto funzionamento e vengono cancellati immediatamente dopo l’elaborazione. 


            <h5 class="text-theme-dark">Cookie strettamente necessari</h5>

Questi cookie sono essenziali per concludere una transazione o per finalizzare una richiesta inizializzata dall’utente. Ad esempio, sono utili per ricordare le informazioni fornite dall’utente durante la
navigazione nel sito al fine di rispondere ad una richiesta espressa dell’Utente ovvero per gestire lo
stato di accesso durante la sessione. 

            
            <h5 class="text-theme-dark">Cookie funzionali</h5>

            Questi cookie consentono al Sito Internet di ricordare le scelte effettuate dall’utente al fine di ottimizzare le funzionalità. Ad esempio, i cookie funzionali consentono al sito di ricordare le impostazioni specifiche di un utente, come la selezione del paese e, se impostato, lo stato di accesso permanente. 


            <h5 class="text-theme-dark">Cookie analitici</h5>

Questi cookie consentono di raccogliere dati sull’utilizzo del Sito Internet da parte dell’utente,
compresi gli elementi su cui si fa clic durante la navigazione, al fine di migliorare le prestazioni e il
design del sito stesso. Potrebbero essere condivisi con i nostri fornitori di strumenti di analisi terzi.
Tuttavia, sono utilizzati esclusivamente per le finalità correlate al nostro Sito Internet. 
            
            <h5 class="text-theme-dark">Cookie Pubblicitari </h5>

            I cookie pubblicitari vengono utilizzati per fornire ai visitatori annunci pubblicitari personalizzati in
base alle pagine visitate in precedenza e per analizzare l’efficacia della campagna pubblicitaria.
Non sono obbligatori e deve essere prestato il consenso all’utilizzo degli stessi.


            <h5 class="text-theme-dark">Cookie tecnici che non richiedono il consenso</h5>

<p>A) Cookie relativi ad attività strettamente necessarie al funzionamento del sito e all’erogazione del
servizio; sono cookie volti a garantire la normale navigazione del sito. Nella maggior parte dei casi
si tratta di cookie di sessione.</p>
<p>B) Cookie relativi ad attività di salvataggio delle preferenze e ottimizzazione: sono cookie che permettono all'utente di navigare sul sito in funzione dei criteri selezionati (come ad esempio la lingua,
la valuta, il contenuto del carrello durante gli acquisti online)
Tutti cookie tecnici non richiedono consenso, perciò vengono automaticamente installati a seguito
dell’accesso al sito e non vengono utilizzati per scopi ulteriori. </p>
            
            <h5 class="text-theme-dark">Cookie per i quali è richiesto il consenso: </h5>

            Qualora l’utente presti il consenso ai cookie di cui all’elenco al momento del primo accesso sul sito
internet <a href="https://www.sarahfitnessmovementflow.com" target="_blank">https://www.sarahfitnessmovementflow.com</a>, può prestare consenso unico a che la ditta
individuale di Abdessalem Sarah e le terze parti indicate installino sul suo dispositivo i predetti
cookie e pongano in essere i conseguenti trattamenti di profilazione o negare tale consenso alla ditta
individuale di Abdessalem Sarah e ad ogni altra società. 


            
            <h5 class="text-theme-dark">Cookie di statistica </h5>
Vengono utilizzati per monitorare il comportamento dell’utente sul sito. Questi cookie sono utili al
fine di migliorare la navigazione dei visitatori. Nessuna vostra informazione personale viene trattenuta perché, utilizzando questi strumenti di analisi, non si ha modo di risalire alla vostra identità.
Essi si occupano di identificare le parti del sito che non funzionano nel modo corretto in modo da
poter intervenire e migliorare i servizi. 

            
            <h5 class="text-theme-dark">Cookie pubblicitari </h5>

            Utilizzati per proporre all’utente determinate pubblicità in base alle sue preferenze, dunque sono
cookie indispensabili per il trattamento denominato “Marketing”. 

<br><br>

            <div class="row">
            <div class="col-md-12">
<table class="cookie-table">
  <tr>
    <th>Nome</th>
    <th>Durata</th>
    <th>Descrizione</th>
  </tr>
  <tr><td>KHcl0EuY7AKSMgfvHl7J5E7hPtK<td></td><td>Cookie di terze parti (Pay Pal)</td></tr>
<tr><td>TfXMWj95u2_Zf1Kmv_GCUOjlGG8<td></td><td>Cookie di terze parti (Pay Pal)</td></tr>
<tr><td>WELCOME_ASYNC <td></td><td>Cookie di terze parti (Pay Pal)</td></tr>
<tr><td>X-PP-ADS <td></td><td>Cookie di terze parti (Pay Pal)</td></tr>
<tr><td>_ga <td></td><td>Cookie di terze parti (Pay Pal)</td></tr>
<tr><td>cd_user_id <td></td><td>Cookie di terze parti (Pay Pal)</td></tr>
<tr><td>consumer_display <td></td><td>Cookie di terze parti (Pay Pal)</td></tr>
<tr><td>cookie_check <td></td><td>Cookie di terze parti (Pay Pal)</td></tr>
<tr><td>cookie_prefs <td></td><td>Cookie di terze parti (Pay Pal)</td></tr>
<tr><td>d_id <td></td><td>Cookie di terze parti (Pay Pal)</td></tr>
<tr><td>feel_cookie <td></td><td>Cookie di terze parti (Pay Pal)</td></tr>
<tr><td>login_email <td></td><td>Cookie di terze parti (Pay Pal)</td></tr>
<tr><td>navlns <td></td><td>Cookie di terze parti (Pay Pal)</td></tr>
<tr><td>rmuc <td></td><td>Cookie di terze parti (Pay Pal)</td></tr>
<tr><td>ts <td></td><td>Cookie di terze parti (Pay Pal)</td></tr>
<tr><td>ts_c <td></td><td>Cookie di terze parti (Pay Pal)</td></tr>
<tr><td>ui_experience <td></td><td>Cookie di terze parti (Pay Pal)</td></tr>
<tr><td>x-pp-p <td></td><td>Cookie di terze parti (Pay Pal)</td></tr>
<tr><td>_ga <td>14 mesi</td> <td>Cookie necessario al funzionamento di Google Analytics</td></tr>
<tr><td>_gat_gtag_UA_18416642_13 <td>1 minuto</td>  <td>Cookie necessario al funzionamento di Google Analytics</td></tr>
<tr><td>_gid <td>1 giorno</td> <td>Cookie necessario al funzionamento di Google Analytics</td></tr>
<tr><td>_evga_ad7f <td></td><td>Cookie di terze parti (Pay Pal)</td></tr>
<tr><td>kampyleSessionPageCounter<td></td><td>Cookie di terze parti (Pay Pal)</td></tr>
<tr><td>kampyleUserSession <td></td><td>Cookie di terze parti (Pay Pal)</td></tr>
<tr><td>kampyleUserSessionsCount <td></td><td>Cookie di terze parti (Pay Pal)</td></tr>
</table>
</div>
</div>


<br><br>
            <h5 class="text-theme-dark">Google Analytics </h5>

            <p>
              Come riferito e come si può evincere dal nome setsso il cookie “Google Analytics” e tutti in suoi
derivati sono dei cookie analitici che raccolgono dati personali. I dati personali trattati riguardano i
dati di utilizzo e lo strumento di tracciamento (IP, tempo di utilizzo ecc). Google Ireland
Limited potrebbe utilizzare i Dati Personali per contestualizzare e personalizzare gli annunci del
proprio network pubblicitario. Il luogo del trattamento è l’Irlanda. 
            </p>

             <p>
              In ogni caso, per completezza e per trasparenza nei confronti dei propri utenti, L.O.B. S.r.l. provvede ad indicare di seguito il link di rimando alla privacy policy di Google, ove sono dettagliate tutte
le specifiche inerenti il funzionamento di Google Analytics: https://policies.google.com/privacy.
Allo stesso modo i Cookie collegati a YouTube, piattaforma appartenente a Google, sono regolati
dalla citata privacy policy, consultabile all’apposito Link.  
            </p>


            
            <h5 class="text-theme-dark">Supporto nella configurazione del proprio browser</h5>

            <p>
              Come si disattivano o si rimuovono i cookie nel suo browser? Il processo per controllare ed eliminare i cookie varia a seconda del browser utilizzato. Per scoprire come fare con un browser in particolare, è possibile utilizzare la funzione Aiuto del menù su cui viene spiegato, passo dopo passo,
come controllare ed eliminare i cookie: 
            </p>
              

            <p>Internet Explorer</p>
            
            <p><a class="break-word" href="http://windows.microsoft.com/it-it/internet-explorer/delete-manage-cookies#ie=ie-11" target="_blank">http://windows.microsoft.com/it-it/internet-explorer/delete-manage-cookies#ie=ie-11</a></p>

            
            <p>Mozilla Firefox </p>

            <p><a class="break-word" href="https://support.mozilla.org/it/kb/Eliminare%2520i%2520cookie" target="_blank">https://support.mozilla.org/it/kb/Eliminare%2520i%2520cookie</a></p>

            
            <p>Safari </p>

            <p><a class="break-word" href="https://support.apple.com/it-it/HT201265" target="_blank">https://support.apple.com/it-it/HT201265</a></p>

            
            <p>Chrome</p>

            <p><a class="break-word" href="https://support.google.com/accounts/answer/32050?hl=it" target="_blank">https://support.google.com/accounts/answer/32050?hl=it</a></p>

Le ricordiamo che qualora lei abbia effettuato le sue scelte navigando sulle pagine di L.O.B. S.r.l.
da un diverso dispositivo o semplicemente un differente browser non saremo in condizioni di riconoscere le sue opzioni e le riproporremo l’informativa, chiedendole di effettuare nuovamente le sue
scelte.
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>

.cookie-table{
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

.cookie-table td, #customers th {
  border: 1px solid #ddd;
  padding: 2px;
overflow-wrap: break-word;
  word-wrap: break-word;line-break: anywhere;
}

.cookie-table tr:nth-child(even){background-color: #f2f2f2;}

.cookie-table tr:hover {background-color: #ddd;}

.cookie-table th {
  border: 1px solid #ddd;
  padding: 12px;
  text-align: left;
  background-color: #ddd;
  color: #333;
}

.break-word{
  
overflow-wrap: break-word;
  word-wrap: break-word;
}

</style>

<script>
export default {
  name: 'Cookies'
}
</script>